var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 32,
    viewBox: "0 0 115 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2994_3776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2599 4.15747H85.9767V28.7939H91.2599V4.15747Z",
    fill: "#CA27CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.595 4.15747H100.077L91.3273 15.5277L100.735 28.7939H107.706L97.1635 15.3233L106.595 4.15747Z",
    fill: "#CA27CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6186 4.15723H14.0998L5.35052 15.5277L14.7582 28.7942H21.7291L11.1868 15.3233L20.6186 4.15723Z",
    fill: "#CA27CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28314 4.15723H0V28.7942H5.28314V4.15723Z",
    fill: "#CA27CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5548 3.73486C24.2862 3.73486 19.003 9.47178 19.003 16.4757V16.5461C19.003 23.5501 24.219 29.2165 31.4876 29.2165C35.5534 29.2165 38.9971 27.4207 41.2433 24.6129V8.26375C39.015 5.49491 35.6043 3.73487 31.5548 3.73487L31.5548 3.73486ZM38.6217 16.5461C38.6217 20.7696 35.7276 24.2188 31.5548 24.2188C27.382 24.2188 24.4209 20.6992 24.4209 16.4757V16.4053C24.4209 12.1819 27.3148 8.7327 31.4876 8.7327C35.6604 8.7327 38.6217 12.2522 38.6217 16.4757V16.5461V16.5461Z",
    fill: "#CA27CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4333 3.73462C68.5293 3.73462 65.2927 5.69698 63.2758 8.73046V24.2192C65.4261 27.3542 68.9356 29.2163 73.0079 29.2163C77.2971 29.2163 80.3483 27.4127 82.5592 24.6379L79.4195 21.7244C77.5625 23.6205 75.7054 24.6379 73.0965 24.6379C69.6475 24.6379 66.9944 22.4181 66.3754 18.4409H83.5319C83.576 17.886 83.6204 17.4235 83.6204 16.9148C83.6204 9.83907 79.8617 3.73462 72.4333 3.73462V3.73462ZM66.3312 14.7412C66.8176 10.9491 69.1168 8.313 72.3889 8.313C75.9264 8.313 77.9605 11.134 78.3142 14.7412H66.3312Z",
    fill: "#CA27CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8915 19.3265V4.15751H57.8915L57.8917 4.15721V0L46.2732 4.15721L46.2735 4.15751H46.2732L57.8915 19.3265Z",
    fill: "#CA27CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6274 28.794H46.6554L46.6274 28.8218V32.0001L58.6355 28.794L46.6274 13.1323V28.794Z",
    fill: "#CA27CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.94 4.59924H109.197V7.86579H109.708V4.59924H110.965V4.15747H107.94V4.59924Z",
    fill: "#CA27CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.281 4.15747L113.215 7.29275L112.142 4.15747H111.418V7.86579H111.9V5.67714C111.9 5.58963 111.898 5.4529 111.893 5.26695C111.888 5.08097 111.885 4.94255 111.885 4.85168V4.73809L112.961 7.86579H113.462L114.527 4.73809C114.527 4.93835 114.526 5.126 114.522 5.30101C114.519 5.47604 114.517 5.60143 114.517 5.67714V7.86579H115V4.15747H114.281V4.15747Z",
    fill: "#CA27CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2994_3776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d07e7fda.svg";
export { ForwardRef as ReactComponent };